import { render } from "./Todo.vue?vue&type=template&id=f0057112&bindings={\"add\":\"options\",\"remove\":\"options\",\"upper\":\"options\"}"
import script from "./Todo.vue?vue&type=script&lang=js"
export * from "./Todo.vue?vue&type=script&lang=js"

import "./Todo.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script